// Earth environment layers that genuinely render. Only these identifiers and
// user state (visible/opacity/order) are saved; Cesium providers are rebuilt
// by the viewer and never persisted. Cesium ion layers need a configured ion
// token; without it they are not offered at all. RVT/IFC/DWG/point clouds and
// survey/BIM georeferencing have no verified renderer and are not layers.
export const EARTH_LAYERS = Object.freeze([
  { id: 'osm-imagery', type: 'imagery', label: 'Street map', note: '© OpenStreetMap contributors', requiresIon: false },
  { id: 'ion-world-imagery', type: 'imagery', label: 'Satellite imagery', note: 'Cesium ion', requiresIon: true },
  { id: 'ion-world-terrain', type: 'terrain', label: 'Terrain', note: 'Cesium World Terrain', requiresIon: true },
  { id: 'ion-osm-buildings', type: '3d-tiles', label: '3D buildings', note: 'Cesium OSM Buildings (context only)', requiresIon: true },
]);

export function ionToken(env = process.env) {
  return env.REACT_APP_CESIUM_ION_TOKEN || (typeof window !== 'undefined' && window.CESIUM_ION_TOKEN) || '';
}

export function availableEarthLayers(token = ionToken()) {
  return EARTH_LAYERS.filter(layer => !layer.requiresIon || Boolean(token));
}

export function layerState(document, id) {
  return (document?.layers || []).find(layer => layer.id === id) || null;
}

// Toggle a layer in the document. Order is preserved; one terrain at most.
export function setLayer(document, id, change) {
  const known = EARTH_LAYERS.find(layer => layer.id === id);
  if (!known) return document;
  const layers = [...(document.layers || [])];
  const index = layers.findIndex(layer => layer.id === id);
  const next = { ...(index >= 0 ? layers[index] : { id, visible: false }), ...change, type: known.type };
  if (index >= 0) layers[index] = next; else layers.push(next);
  return { ...document, layers };
}

export function layerType(id) {
  return EARTH_LAYERS.find(layer => layer.id === id)?.type || null;
}

export function terrainActive(document) {
  return (document?.layers || []).some(layer => layer.id === 'ion-world-terrain' && layer.visible !== false);
}

// Cesium errors may contain an authenticated URL or response body. Keep the
// existing error surface actionable without echoing credentials into the UI.
export function terrainFailureMessage(error) {
  const status=Number(error?.statusCode ?? error?.status ?? error?.error?.statusCode);
  if(status===401 || status===403)return `Terrain authentication failed (HTTP ${status}). Check REACT_APP_CESIUM_ION_TOKEN, read access to Cesium World Terrain asset 1, and allowed URLs. Your saved project is preserved.`;
  return 'Terrain is unavailable. Check the connection and configured Cesium access, then Retry viewer. Your saved project is preserved.';
}
